import * as React from 'react';
import { AnimatedCollapsibleContent } from './collapsible/AnimatedCollapsibleContent';
import { PageSectionHeader, PageSectionHeaderProps } from './PageSectionHeader';
import { PageSectionVariant } from './PageSectionDefs';
import { PageSectionContent } from './PageSectionContent';



export type PageSectionProps = {
    // defaultCollapsed and  - not in its header
    header?:Omit<PageSectionHeaderProps, 'headerStyleVariant' | 'contentStyleVariant'> & {
        title:string
    },
    headerStyleVariant?:PageSectionVariant,
    contentStyleVariant?:PageSectionVariant,
    contentPadding?: string;
    onCollapsedChanged?:(collapsed:boolean)=>void,
}

export const PageSection = (props:React.PropsWithChildren<PageSectionProps>): JSX.Element => {
    const [collapsed, setCollapsed] = React.useState(
        props.header?.defaultCollapsed === undefined ? false : props.header.defaultCollapsed
    );

    React.useEffect(() => {
        if(props.header?.defaultCollapsed !== undefined && props.header.defaultCollapsed !== collapsed)
            setCollapsed(props.header.defaultCollapsed);
    }, [props.header?.defaultCollapsed]);

    function handleCollapseChanged(collapsed:boolean)
    {
        setCollapsed(collapsed);
        props.onCollapsedChanged?.(collapsed);
    }

    if(props.header === undefined)
        return  <PageSectionContent 
                    headerStyleVariant={props.headerStyleVariant || 'minimal'}
                    contentStyleVariant={props.contentStyleVariant || 'minimal'}
                    padding={props.contentPadding}
                    hasHeader={false}>

                    {props.children}

                </PageSectionContent>;

    return (


        <div>
            <PageSectionHeader {...props.header} 
                headerStyleVariant={props.headerStyleVariant || 'minimal'}
                contentStyleVariant={props.contentStyleVariant || 'minimal'}
                defaultCollapsed={props.header?.defaultCollapsed}
                onCollapseChanged={handleCollapseChanged}>

                {props.header.title}

            </PageSectionHeader>


            <AnimatedCollapsibleContent open={!collapsed}>
                <PageSectionContent 
                    headerStyleVariant={props.headerStyleVariant || 'minimal'}
                    contentStyleVariant={props.contentStyleVariant || 'minimal'}
                    padding={props.contentPadding}
                    hasHeader={true}>

                    {props.children}

                </PageSectionContent>
            </AnimatedCollapsibleContent>
        </div>
    );
};